
import React from 'react';
import Chart from 'react-apexcharts'

export default function DataChart ({dataChart,labelsChart,nameLabels,uM}) { 
    let auxarray = dataChart.map(function(x){ return  x.toString().replace(".","") });
    auxarray = auxarray.map(function(x){ return  x.toString().replace(",","") });

    const config = {
        series: [{
          name: nameLabels,
          data: auxarray
        }],
        options: {
          chart: {
            zoom: {
              enabled: false
            },
            height: 250,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 0,
              dataLabels: {
                position: 'top',
              },
            }
          },
          colors: [
            function({ value, seriesIndex, dataPointIndex, w }) {
              if (dataPointIndex === 0 || dataPointIndex === 12) {
                return '#f18a00'
              } else {
                return '#00a7e1'
              }
            }
          ],
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: -15,
            style: {
              fontSize: '12px',
              colors: ["#354044"],
            }
          },
          xaxis: {
            categories: labelsChart,
            position: 'botton',
            axisBorder: {
              show: true
            },
            axisTicks: {
              show: true
            },
            crosshairs: {
              fill: {
                type: 'gradient',
                gradient: {
                  colorFrom: '#D8E3F0',
                  colorTo: '#BED1E6',
                  stops: [0, 300],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                }
              }
            },
            tooltip: 
            {
              enabled: true,
            }
          },
          yaxis: {
            title: {
              text: `Consumo(${uM})`
            },
            axisBorder: {
              show: true
            },
            axisTicks: {
              show: true,
            },
            labels: {
              show: true,
              formatter: function (val) {
                return val + ' ' +  uM;
              }
            },
            tooltip: 
            {
              enabled: false,
              y:{
                formatter: function (val) {
                  return val + uM;
                }
              }
            }
          }
        }
    };

	return (
        <Chart options={config.options} series={config.series} type="bar" width={800} height={250} />
	);
}
